import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  BUTTON_DISCARD,
  BUTTON_RETRY,
  MODAL_CREATE_WITH_IA_GENERATION_FAILED,
} from "../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";
import Button from "../../Buttons/Button";

const getAspectRatioCss = (aspectRatio) =>
  aspectRatio ? String(aspectRatio).replace(":", "/") : "1";

const GenerationFailedCard = ({
  data = {},
  onRetry = () => {},
  onDismiss = () => {},
}) => {
  const { t } = useTranslationApp();
  const errorMessage =
    typeof data.errorMessage === "string" ? data.errorMessage : "";

  const onRetryClick = () => {
    onRetry(data.generationID);
  };

  const onDismissClick = () => {
    onDismiss(data.generationID);
  };

  return (
    <Box
      data-testid="generation-failed-card"
      sx={{
        position: "relative",
        aspectRatio: getAspectRatioCss(data.aspectRatio),
        minHeight: 220,
        bgcolor: "grey.100",
        borderRadius: 2,
        border: 1,
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 1,
        width: "100%",
        overflow: "auto",
        p: 2,
        textAlign: "center",
      }}
    >
      <ErrorOutlineIcon color="error" />
      <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
        {t(MODAL_CREATE_WITH_IA_GENERATION_FAILED)}
      </Typography>
      {errorMessage ? (
        <Typography variant="caption" color="text.secondary">
          {errorMessage}
        </Typography>
      ) : null}
      <Box sx={{ display: "flex", gap: 1, mt: 1, width: "100%" }}>
        {data.canRetry !== false ? (
          <Button color="primary" size="small" fullWidth onClick={onRetryClick}>
            {t(BUTTON_RETRY)}
          </Button>
        ) : null}
        <Button
          color="secondary"
          size="small"
          fullWidth
          onClick={onDismissClick}
        >
          {t(BUTTON_DISCARD)}
        </Button>
      </Box>
    </Box>
  );
};

export default GenerationFailedCard;
